  export const flux = require('./icon-models/flux.png')
  export const stablediff = require('./icon-models/stable-diff.png')
  export const kimi = require('./icon-models/kimi.png')
  export const kling = require('./icon-models/kling.png')
  export const perplexity = require('./icon-models/perplexity.png')
  export const grok = require('./icon-models/grok.png')
  export const gemini = require('./icon-models/gemini.png')
  export const deepseek = require('./icon-models/deepseek.png')
  export const deepmind = require('./icon-models/deepmind.png')
  export const bytedance = require('./icon-models/bytedance.png')

  export const iconModels = [
    { name: 'Gemini', src: gemini },
    { name: 'Grok', src: grok },
    { name: 'Perplexity', src: perplexity },
    { name: 'DeepSeek', src: deepseek },
    { name: 'Flux', src: flux },
    { name: 'Kling', src: kling },
    { name: 'DeepMind', src: deepmind },
    { name: 'Stable Diffusion', src: stablediff },
    { name: 'ByteDance', src: bytedance },
    { name: 'Kimi', src: kimi },
  ]

  export default iconModels;